import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, of, throwError } from 'rxjs';
import { catchError, switchMap } from 'rxjs/operators';
import { AuthUtils } from 'app/core/auth/auth.utils';
import { UserService } from 'app/core/user/user.service';
import { Md5 } from 'ts-md5/dist/md5';
import { environment } from 'environments/environment';
import {
    MatSnackBar,
    MatSnackBarHorizontalPosition,
    MatSnackBarVerticalPosition,
} from '@angular/material/snack-bar';
// import SecureLS from 'secure-ls';
// var ls = new SecureLS({ encodingType: 'base64' });
import ls from 'localstorage-slim';
@Injectable({
    providedIn: 'root'
})
export class AuthService {
    bnfDtls;
    isAuthenticated() {
        throw new Error('Method not implemented.');
    }
    horizontalPosition: MatSnackBarHorizontalPosition = 'end';
    verticalPosition: MatSnackBarVerticalPosition = 'top';
    public _authenticated: boolean = false;
    private _baseURL: string = environment.apiOrigin + '/apiv1/auth/'


    /**
     * Constructor
     */
    constructor(private _snackBar: MatSnackBar,
        private _httpClient: HttpClient,
        private _userService: UserService
    ) {
    }

    // -----------------------------------------------------------------------------------------------------
    // @ Accessors
    // -----------------------------------------------------------------------------------------------------

    /**
     * Setter & getter for access token
     */

    accessToken(): string {
        let access_token: string = ls.get('accessToken');
        if (access_token && access_token != 'undefined') {
            return access_token;
        } else {
            return null;
        }
    }

    mustChangePassword(): boolean {
        try {
            const rawUser = localStorage.getItem('userdata');
            if (!rawUser) {
                return false;
            }
            const user = JSON.parse(rawUser);
            return Number(user?.chnge_pwd_in) === 1;
        } catch (error) {
            return false;
        }
    }

    persistUserData(user: any): void {
        if (!user) {
            return;
        }
        const normalizedUser = {
            ...user,
            user_lgn_nm: user.user_lgn_nm || user.usr_nm || '',
            mble_ph: user.mble_ph || '',
            chnge_pwd_in: Number(user.chnge_pwd_in) || 0
        };
        localStorage.setItem('userdata', JSON.stringify(normalizedUser));
    }

    // -----------------------------------------------------------------------------------------------------
    // @ Public methods
    // -----------------------------------------------------------------------------------------------------

    /**
     * Forgot password
     *
     * @param data
     */
    forgotPassword(data): Observable<any> {
        return this._httpClient.post(this._baseURL + 'forgot-password/send-otp', { data: data });
    }

    /**
     * Reset password
     *
     * @param password
     */
    resetPassword(data): Observable<any> {
        console.log(data, 'resetPasswordddddddddddddddddddddddd')
        return this._httpClient.post(this._baseURL + 'forgot-password/validate-otp', { data: data });
    }

    /**
     * Sign up
     *
     * @param user
     */
    signUp(user: { name: string; email: string; password: string; company: string }): Observable<any> {
        return this._httpClient.post(this._baseURL + 'sign-up', user);
    }

    /**
     * Sign in
     *
     * @param credentials
     */
    signIn(credentials): Observable<any> {
        // Throw error, if the user is already logged in
        if (this._authenticated) {
            return throwError('User is already logged in.');
        }

        return this._httpClient.post(this._baseURL + 'login', credentials, { observe: 'response' }).pipe(
            catchError((error) => {
                if (error.error.message) {
                    return throwError(error.error.message.message);
                } else {
                    return of(false);
                }
            }),
            switchMap((response: any) => {
                if (response.body && response.body.status == 200 && response.body.data) {
                    let resData = response.body.data
                    console.log(resData);
                    console.log(resData['user']['roles']['rle_nm']);
                    if (resData && resData['user']['roles']['rle_nm'] == "BCCFC Benificary ") {
                        console.log('innnnn 111');

                        this._httpClient.get(this._baseURL + 'getBenfId/' + resData.user['usr_id']).subscribe(res => {
                            console.log('innnnn');

                            if (res['status'] == 404) {
                                console.log('innnnn 404');

                            } else if (res['status'] == 200) {
                                console.log('innnnn 200');

                                console.log(res);
                                this.bnfDtls = res['data'];
                                if (this.bnfDtls && this.bnfDtls.length > 0) {
                                    console.log('innnnn 44444');

                                    resData['user']['benf_id'] = this.bnfDtls[0]['bnfcy_id'];
                                    console.log('resDataresData', resData)


                                    // Store the access token in the local storage
                                    ls.set('accessToken', resData.accessToken);

                                    // Set the authenticated flag to true
                                    this._authenticated = true;
                                    if (resData && resData['user']) {
                                        console.log('11111111111111111111111', resData['user']);
                                        console.log('77777', JSON.stringify(resData['user']));
                                        this.persistUserData(resData['user']);
                                    }
                                }
                            }
                        })
                    } else {
                        console.log('resDataresData', resData)


                        // Store the access token in the local storage
                        ls.set('accessToken', resData.accessToken);

                        // Set the authenticated flag to true
                        this._authenticated = true;
                        if (resData && resData['user']) {
                            console.log('11111111111111111111111', resData['user']);
                            console.log('77777', JSON.stringify(resData['user']));
                            this.persistUserData(resData['user']);
                        }
                    }



                    // Store the user on the user service
                    this._userService.user = resData.user;
                    this._userService.userClients = resData.clnts;

                    // Force users with password-reset flag to land on profile security screen.
                    const mustResetNow = Number(resData?.user?.chnge_pwd_in) === 1;
                    return of({ url: mustResetNow ? '/profile' : resData.assignedProfiles.mnu_home_pg });
                } else {
                    if (response.body.message) {
                        return throwError(response.body.message);
                    } else {
                        return of(false);
                    }
                }
            })
        );
    }

    mobilesotpignIn(credentials): Observable<any> {
        // Throw error, if the user is already logged in
        if (this._authenticated) {
            return throwError('User is already logged in.');
        }

        return this._httpClient.post(this._baseURL + '/app/verify/otp', credentials, { observe: 'response' }).pipe(
            catchError((error) => {
                if (error.error.message) {
                    return throwError(error.error.message.message);
                } else {
                    return of(false);
                }
            }),
            switchMap((response: any) => {
                if (response.body && response.body.status == 200 && response.body.data) {
                    let resData = response.body.data
                    console.log(resData);
                    console.log(resData['user']['roles']['rle_nm']);
                    if (resData && resData['user']['roles']['rle_nm'] == "BCCFC Benificary ") {
                        console.log('innnnn 111');

                        this._httpClient.get(this._baseURL + 'getBenfId/' + resData.user['usr_id']).subscribe(res => {
                            console.log('innnnn');

                            if (res['status'] == 404) {
                                console.log('innnnn 404');

                            } else if (res['status'] == 200) {
                                console.log('innnnn 200');

                                console.log(res);
                                this.bnfDtls = res['data'];
                                if (this.bnfDtls && this.bnfDtls.length > 0) {
                                    console.log('innnnn 44444');

                                    resData['user']['benf_id'] = this.bnfDtls[0]['bnfcy_id'];
                                    console.log('resDataresData', resData)


                                    // Store the access token in the local storage
                                    ls.set('accessToken', resData.accessToken);

                                    // Set the authenticated flag to true
                                    this._authenticated = true;
                                    if (resData && resData['user']) {
                                        console.log('11111111111111111111111', resData['user']);
                                        console.log('77777', JSON.stringify(resData['user']));
                                        this.persistUserData(resData['user']);
                                    }
                                }
                            }
                        })
                    } else {
                        console.log('resDataresData', resData)


                        // Store the access token in the local storage
                        ls.set('accessToken', resData.accessToken);

                        // Set the authenticated flag to true
                        this._authenticated = true;
                        if (resData && resData['user']) {
                            console.log('11111111111111111111111', resData['user']);
                            console.log('77777', JSON.stringify(resData['user']));
                            this.persistUserData(resData['user']);
                        }
                    }



                    // Store the user on the user service
                    this._userService.user = resData.user;
                    this._userService.userClients = resData.clnts;

                    // Force users with password-reset flag to land on profile security screen.
                    const mustResetNow = Number(resData?.user?.chnge_pwd_in) === 1;
                    return of({ url: mustResetNow ? '/profile' : resData.assignedProfiles.mnu_home_pg });
                } else {
                    if (response.body.message) {
                        return throwError(response.body.message);
                    } else {
                        return of(false);
                    }
                }
            })
        );
    }


    mobilesignIn(data): Observable<any> {
        return this._httpClient.post(this._baseURL + 'app/otp',data);
    }

    /**
     * Get captcha
     */
    getCaptcha(): Observable<any> {
        return this._httpClient.get(this._baseURL + 'login/captcha');
    }

    /**
     * Sign out
     */
    signOut(): Observable<any> {
        // Set the authenticated flag to false
        this._authenticated = false;
        return this._httpClient.get(this._baseURL + 'logout');
    }

    onAuthError(message) {
        this._authenticated = false;
        this.openSnackBar(message, 'mat-primary');
    }

    getMD5EncryptTxt = (plnTxt: string) => {
        const md5 = new Md5();
        return md5.appendStr(plnTxt).end();
    }

    // -----------------------------------------------------------------------------------------------------
    // @ Accessors
    // -----------------------------------------------------------------------------------------------------
    openSnackBar(msg, cls) {
        this._snackBar.open(msg, '', {
            duration: 3000,
            horizontalPosition: this.horizontalPosition,
            verticalPosition: this.verticalPosition,
            panelClass: ['mat-toolbar', cls]
        });
    }

    /***
     * Setup routes
     */

    getSetUpProfile(): Observable<any> {
        return this._httpClient.get(this._baseURL + 'setup/profile');
    }
    getClients(): Observable<any> {
        return this._httpClient.get(this._baseURL + 'clients/master');
    }
    addClient(data): Observable<any> {
        return this._httpClient.post(this._baseURL + 'clients/master', { data: data });
    }
    updateClient(data, id): Observable<any> {
        return this._httpClient.put(this._baseURL + 'clients/master/' + id, { data: data });
    }
    deleteClient(id): Observable<any> {
        return this._httpClient.delete(this._baseURL + 'clients/master/' + id);
    }
    getTenants(clnt_id): Observable<any> {
        return this._httpClient.get(this._baseURL + 'client/tenants/master/' + clnt_id);
    }
    addTenant(data): Observable<any> {
        return this._httpClient.post(this._baseURL + 'client/tenants/master/' + data.clnt_id, { data: data });
    }
    updateTenant(data, id): Observable<any> {
        return this._httpClient.put(this._baseURL + 'client/tenants/master/' + id, { data: data });
    }
    deleteTenant(id): Observable<any> {
        return this._httpClient.delete(this._baseURL + 'client/tenants/master/' + id);
    }
    getUsers(): Observable<any> {
        return this._httpClient.get(this._baseURL + 'users');
    }
    addUser(data): Observable<any> {
        return this._httpClient.post(this._baseURL + 'users', { data: data });
    }
    updateUser(data, id): Observable<any> {
        return this._httpClient.put(this._baseURL + 'users/' + id, { data: data });
    }
    deleteUser(id): Observable<any> {
        return this._httpClient.delete(this._baseURL + 'users/' + id);
    }
    getRoles(): Observable<any> {
        return this._httpClient.get(this._baseURL + 'roles');
    }
    addRole(data): Observable<any> {
        return this._httpClient.post(this._baseURL + 'roles', { data: data });
    }
    updateRole(data, id): Observable<any> {
        return this._httpClient.put(this._baseURL + 'roles/' + id, { data: data });
    }
    deleteRole(id): Observable<any> {
        return this._httpClient.delete(this._baseURL + 'roles/' + id);
    }
    getDepartments(): Observable<any> {
        return this._httpClient.get(this._baseURL + 'departments/list');
    }
    addDepartment(data): Observable<any> {
        return this._httpClient.post(this._baseURL + 'departments/master', { data: data });
    }
    updateDepartment(data, id): Observable<any> {
        return this._httpClient.put(this._baseURL + 'departments/master/' + id, { data: data });
    }
    deleteDepartment(id): Observable<any> {
        return this._httpClient.delete(this._baseURL + 'departments/master/' + id);
    }
    getOrganizations(): Observable<any> {
        return this._httpClient.get(this._baseURL + 'organizations');
    }
    addOrganization(data): Observable<any> {
        return this._httpClient.post(this._baseURL + 'organizations', { data: data });
    }
    updateOrganization(data, id): Observable<any> {
        return this._httpClient.put(this._baseURL + 'organizations/' + id, { data: data });
    }
    deleteOrganization(id): Observable<any> {
        return this._httpClient.delete(this._baseURL + 'organizations/' + id);
    }
    get(rte): Observable<any> {
        return this._httpClient.get(this._baseURL + rte);
    }
    post(rte, data): Observable<any> {
        return this._httpClient.post(this._baseURL + rte, { data: data });
    }
    put(rte, data): Observable<any> {
        return this._httpClient.put(this._baseURL + rte, { data: data });
    }
    delete(rte): Observable<any> {
        return this._httpClient.delete(this._baseURL + rte);
    }


    getproductCategories(): Observable<any> {
        return this._httpClient.get(this._baseURL + 'products/categories');
    }
    addCtgry(data): Observable<any> {
        return this._httpClient.post(this._baseURL + 'products/categories', { data: data });
    }

    getproductSubCategories(): Observable<any> {
        return this._httpClient.get(this._baseURL + 'products/sub_categories');
    }
    // loggedin user
    getloggedinusr(): Observable<any> {
        return this._httpClient.get(`${environment.apiOrigin}/apiv1/auth/profile/loginUser`);
    }

    /**
     * Unlock session
     *
     * @param credentials
     */
    unlockSession(credentials: { email: string; password: string }): Observable<any> {
        return this._httpClient.post('api/auth/unlock-session', credentials);
    }

    getClctnOfcrAlctdTypArea(): Observable<any> {
        console.log(this._baseURL + 'collection/officer/collection/types')
        return this._httpClient.get(this._baseURL + 'collection/officer/collection/types');
    }

    /**
     * Check the authentication status
     */
    check(): Observable<boolean> {
        // Check if the user is logged in
        if (this._authenticated) {
            return of(true);
        }

        // Check the access token availability
        if (!this.accessToken()) {
            return of(false);
        }

        // Check the access token expire date
        if (AuthUtils.isTokenExpired(this.accessToken())) {
            console.log('Token Expired, getting refresh token');
            // return of(false);
        }

        return of(true);
    }

    // getsetupdata(): Observable<any> {
    //     return this._httpClient.get(this._baseURL + 'setup/profile');
    // }


    // get UrlBased Bannel
    getUrlBasedbannel(): Observable<any> {
        const data = {
            host: location.hostname,
            origin: location.origin
        };
        console.log(data)
        return this._httpClient.post(this._baseURL + 'app/origin', { data: data });
    }


    // getBnfId(usr_id){return this._httpClient.get(this._baseURL + 'getBenfId' + usr_id);}


}

